import { baseCommand } from "./basecommand";

type devTypename = "dev"
type commands = "reset" | "freeze" | "unfreeze" | "quit"
type developdatatype = {
    "command": commands;
}

type pscommand<T> = {
    "type": T extends devTypename ? T : never;
    "data": T extends devTypename ? developdatatype : never;
};

export type developCommand = pscommand<devTypename>;

export class develop extends baseCommand {
    constructor(private command: commands ) {
        super();
    }

    public object(): developCommand {
        return {
            "type":"dev",
            "data":{
                "command" : this.command
            }
        }
    }
}
